<script>
import * as PIXI from 'pixi.js'
import { checkBoxCollision } from '../../library/collision.js';

export default {
	// Gets us the provider property from the parent <pixi-stage> component.
	inject: ['EventBus', 'provider'],

	props: {
		scale: {
			type: Number,
			default: 1
		},

		imageUrl: {
			type: String,
			required: true
		},

		localY: {
			type: Number,
			default: 800
		},

		localX: {
			type: Number,
			default: 400
		},

		locked: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {}
	},

	render: function(h) {
		return h('template', this.$slots.default)
	},

	methods: {
		onPixiReady() {
			this.app = this.provider.app;
			this.stage = this.app.stage;

			this.playset.anchor.set(0.5);
			this.playset.position.set(this.localX, this.localY);

			this.playset.visible = false;

			this.offset = { x: 0, y: 0 };

			this.setPlaysetScale();
			this.snapToBounds();
			//this.setHelperPoint();

			if(this.locked) {
				this.setLock();
			}

			this.provider.playsetContainer.addChild(this.playset);

			if(this.hasPlaysetCollisions(this.playset)) {
				this.$emit('collision');
			} else {
				this.playset.visible = true;
			}

		},

		setLock() {
			const lockTexture = new PIXI.Texture.fromImage('/assets/img/lock.png');
			const lock = new PIXI.Sprite(lockTexture);

			const playsetBounds = this.getUnscaledBounds(this.playset);

			lock.width = 50;
			lock.height = 50;
			lock.anchor.set(0.5, 1);

			lock.position.set(
				playsetBounds.x + this.playset.width,
				playsetBounds.y + this.playset.height
			);

			this.provider.app.stage.addChild(lock);
		},

		checkVirtualCollision(box, currentPlayset) {

			return this.provider.playsetContainer.children
				.filter(playset => playset != currentPlayset)
				.some(playset => checkBoxCollision(box, playset.getBounds()));

		},

		onDragStart(event) {
			// store a reference to the data
			// the reason for this is because of multitouch
			// we want to track the movement of this particular touch
			this.playset.data = event.data;

			const mousePosition = this.getLocalPosition();

			this.playset.startDragPosition = new PIXI.Point();
			this.playset.startDragPosition.copy(this.playset.position);

			this.playset.alpha = 0.5;
			this.playset.dragging = true;
			this.offset = {
				x: this.playset.x - mousePosition.x,
				y: this.playset.y - mousePosition.y
			};

		},
		onDragEnd(event) {
			this.playset.alpha = 1;
			this.playset.dragging = false;

			// set the interaction data to null
			this.playset.data = null;
			this.playset.tint = 0xFFFFFF;

			if( this.hasTrashCollision() ) {
				this.$emit('destroy');
			}

			// if (this.isUnderLine() || this.isOutOfBounds()) {
			// 	this.playset.x = this.playset.startDragPosition.x;
			// 	this.playset.y = this.playset.startDragPosition.y;
			// }

			this.snapToBounds();

			if(this.hasPlaysetCollisions(this.playset)) {
				this.playset.x = this.playset.startDragPosition.x;
				this.playset.y = this.playset.startDragPosition.y;
			}

			this.setPlaysetScale();
			this.provider.playsetContainer.updateLayersOrder();

			// emit events
			this.$emit('update:localX', this.playset.x);
			this.$emit('update:localY', this.playset.y);
		},

		onDragMove(event) {
			if (this.playset.dragging) {
				const { x, y } = this.getLocalPosition();

				this.playset.x = x + this.offset.x;
				this.playset.y = y + this.offset.y;

				this.setPlaysetScale();
				this.provider.playsetContainer.updateLayersOrder();

				if(
					this.hasPlaysetCollisions(this.playset) ||
					this.hasTrashCollision()
				) {
					this.playset.tint = 0xFF0000;
					this.playset.alpha = 0.8;
				} else {
					this.playset.tint = 0xFFFFFF;
					this.playset.alpha = 0.5;
				}
			}
		},

		getRandomPosition(playset) {
			const playsetBounds = this.playset.getBounds();

			const yMax = this.provider.minLineHeight;
			const yMin = 0 + (playsetBounds.height / 2);
			const xMin = 0 + (playsetBounds.width / 2);
			const xMax = this.provider.width;

			const x = Math.floor((Math.random() * xMax) + xMin);
			const y = Math.floor((Math.random() * yMax) + yMin);

			return {
				y: y,
				x: x
			}
		},

		isUnderLine() {
			return (
				this.playset.y + (this.playset.getBounds().height / 2) < this.provider.minLineHeight
			);
		},

		snapToBounds() {
			const dragBoundries = this.provider.utilsContainer.getChildByName('DragBoundries');

			if(dragBoundries) {

				const bounds = this.getUnscaledBounds(dragBoundries);

				/* PLAYSET HEIGHT AND WIDTH CANNOT BE USED (ONLY WHEN SCALED TO POINT) */

				const x1 = bounds.x + (this.playset.width * this.playset.anchor.x);
				const x2 = bounds.x + bounds.width - (this.playset.width * this.playset.anchor.x);
				const y1 = bounds.y - (this.playset.height * this.playset.anchor.y);
				const y2 = bounds.y + bounds.height;

				if(this.playset.x < x1) {
					this.playset.x = x1 ;
				} else if (this.playset.x > x2) {
					this.playset.x = x2;
				}

				if(this.playset.y < y1) {
					this.playset.y = y1;
				} else if (this.playset.y > y2) {
					this.playset.y = y2;
				}

			} else {
				if (this.playset.x < 0) {
					this.playset.x = 0;
				} else if (this.playset.x > this.provider.width) {
					this.playset.x = this.provider.width;
				}

				if (this.playset.y > this.provider.height) {
					this.playset.y = this.provider.height;
				} else if (this.isUnderLine()) {
					this.playset.y = this.provider.minLineHeight - (this.playset.getBounds().height / 2);
				}
			}
		},

		getUnscaledBounds(object) {
			const anchor = object.anchor

			const x = object.x - (object.width * anchor.x);
			const y = object.y - (object.height * anchor.y);

			return new PIXI.Rectangle(
				x,
				y,
				object.width,
				object.height
			);
		},

		isInBounds() {

			const bounds = this.getUnscaledBounds(dragBoundries);

			/* PLAYSET HEIGHT AND WIDTH CANNOT BE USED (ONLY WHEN SCALED TO POINT) */

			const x1 = bounds.x;
			const x2 = bounds.x + bounds.width;
			const y1 = bounds.y;
			const y2 = bounds.y + bounds.height;

			return (
				this.playset.x < x1 ||
				this.playset.x > x2 ||
				this.playset.y < y1 ||
				this.playset.y > y2
			);
		},

		setHelperPoint(position) {
			const squareFar = new PIXI.Sprite(PIXI.Texture.WHITE);
			squareFar.tint = 0xff0000;
			squareFar.visible = true;
			squareFar.factor = 1;
			squareFar.height = 2;
			squareFar.width = 2;
			squareFar.anchor.set(0,0);
			squareFar.position.set(position.x, position.y);
			//squareFar.position.set(this.localX, this.localY);
			this.provider.app.stage.addChild(squareFar);
		},

		calculateScale(currentScale) {
			const maxScalePercentage = 50;
			const maxScale = maxScalePercentage / 100;
			const total = this.provider.height - this.provider.minLineHeight;
			const value = this.playset.y - this.provider.minLineHeight;
			const scale = (maxScale / total * value) * this.scale;
			const newScale = currentScale * (1 - maxScale) + scale;

			return newScale;
		},

		setPlaysetScale() {
			// this.provider.minLineHeight = 80%
			// this.provider.height = 100%;
			if (!this.isUnderLine()) {
				this.playset.scale.set(this.calculateScale(this.scale));
			}
		},

		getLocalPosition() {
			return this.playset.data.getLocalPosition(this.playset.parent);
		},

		hasTrashCollision(currentPlayset) {
			const trash = this.provider.utilsContainer.getChildByName('Trash');

			if(trash && this.checkCollision(this.playset, trash)) {
				return true;
			}

			return false;
		},

		hasPlaysetCollisions(currentPlayset) {

			return this.provider.playsetContainer.children
				.filter(playset => playset != currentPlayset)
				.some((playset) => this.checkCollision(currentPlayset, playset));

		},

		checkCollision(r1, r2) {

			// const r1Bounds = r1.getBounds();
			// const r2Bounds = r2.getBounds();

			const r1Bounds = this.getUnscaledBounds(r1);
			const r2Bounds = this.getUnscaledBounds(r2);

			return checkBoxCollision(r1Bounds, r2Bounds);

		},

		loadImage(callback) {

			/* There could be a loader for all items in PIXI STAGE */
			const loader = PIXI.loader;

			if(loader.resources[this.imageUrl]) {
				callback(loader.resources[this.imageUrl]);
			} else {

				// add a resource to load
				loader.add(this.imageUrl, this.imageUrl);

				// start the loader and pass an anonymous function to be called back once the loading is complete
				loader.load((loader, resources) => {
					callback(resources[this.imageUrl]);
				});
			}
		}
	},

	beforeDestroy() {

		if(this.playset) {
			this.playset.removeAllListeners();
			this.provider.playsetContainer.removeChild(this.playset);
		}

	},

	mounted() {
		const imageUrl = this.imageUrl;

		this.provider.loadPlaysetImage(imageUrl, (image) => {

			// Texture
			image.texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;

			Object.defineProperty(this, 'playset', { value: new PIXI.Sprite(image.texture), configurable: false });

			this.playset.visible = false;

			if(!this.locked) {

				this.playset.interactive = true;
				this.playset.buttonMode = true;

				// Add Event Listeners
				this.playset
					.on('pointerdown', this.onDragStart)
					.on('pointerup', this.onDragEnd)
					.on('pointerupoutside', this.onDragEnd)
					.on('pointermove', this.onDragMove);

			}

			if (this.provider.ready) {
				this.onPixiReady();
			} else {
				this.EventBus.$on('ready', this.onPixiReady);
			}

		});

	}
}
</script>



// WEBPACK FOOTER //
// assets/vue/apps/participate/playset-item.vue